import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "@/pages/home/components/Hero";
import TrustMarquee from "@/pages/home/components/TrustMarquee";
import ProductShowcase from "@/pages/home/components/ProductShowcase";
import Features from "@/pages/home/components/Features";
import Lifestyle from "@/pages/home/components/Lifestyle";
import Specs from "@/pages/home/components/Specs";
import PackageBox from "@/pages/home/components/PackageBox";
import DigitalManual from "@/pages/home/components/DigitalManual";
import InstallGuide from "@/pages/home/components/InstallGuide";
import VideoSection from "@/pages/home/components/VideoSection";
import WhereToBuy from "@/pages/home/components/WhereToBuy";
import Faq from "@/pages/home/components/Faq";
import ContactForm from "@/pages/home/components/ContactForm";

export default function Home() {
  return (
    <main className="w-full overflow-x-hidden bg-background-50 text-foreground-950">
      <Navbar />
      <Hero />
      <TrustMarquee />
      <ProductShowcase />
      <Features />
      <Lifestyle />
      <VideoSection />
      <Specs />
      <PackageBox />
      <DigitalManual />
      <InstallGuide />
      <WhereToBuy />
      <Faq />
      <ContactForm />
      <Footer />
    </main>
  );
}
